import { Layout, Space } from 'antd';
import { useInactivityMonitor } from '@/hooks/useInactivityMonitor';
import { getLayoutColors } from '@/theme/SpeecargoTheme';
import InfoDropdown from './InfoDropdown';
import NavBarFunctions from './NavBarFunctions';

type NavBarProp = {
	currentUser?: API.CurrentUser;
	onLogout: () => void;
};

const Navbar: React.FC<NavBarProp> = ({ currentUser, onLogout }) => {
	const layoutColors = getLayoutColors('speedcargo');

	return (
		<Layout.Header
			style={{
				position: 'fixed',
				top: 0,
				width: '100%',
				zIndex: 1000,
				background: layoutColors.navbar.background,
				boxShadow: layoutColors.navbar.boxShadow,
				padding: '0 24px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				height: layoutColors.navbar.height,
			}}
		>
			{/* Left side */}
			<Space>
				<AssembleLogo />
				<NavBarFunctions />
			</Space>

			{/* Debug: Activity Timers */}
			{/* <ActivityDebugTimer/> */}

			{/* Right Side */}
			{currentUser && (
				<InfoDropdown currentUser={currentUser} onLogout={onLogout} />
			)}
		</Layout.Header>
	);
};

const AssembleLogo: React.FC = () => {
	return (
		<img
			src="/assemble-icon.png"
			alt="logo"
			style={{
				height: 28,
				marginTop: 10,
				display: 'block',
			}}
		/>
	);
};

/* Debug: Activity Timers */
const ActivityDebugTimer: React.FC = () => {
	const { idleSeconds, tokenTTL } = useInactivityMonitor();

	const formatDuration = (totalSeconds: number): string => {
		const m = Math.floor(totalSeconds / 60);
		const s = totalSeconds % 60;
		return `${m}:${String(s).padStart(2, '0')}`;
	};

	return (
		<Space
			style={{
				fontSize: 11,
				fontFamily: 'monospace',
				color: '#8c8c8c',
				background: 'rgba(255,255,255,0.06)',
				borderRadius: 4,
				padding: '2px 10px',
			}}
		>
			<span>
				Idle:{' '}
				<span
					style={{
						color:
							idleSeconds >= 1200
								? '#ff4d4f'
								: idleSeconds >= 600
									? '#faad14'
									: '#52c41a',
					}}
				>
					{formatDuration(idleSeconds)}
				</span>
			</span>
			<span>|</span>
			<span>
				Auto-logout in:{' '}
				<span
					style={{ color: 1500 - idleSeconds <= 300 ? '#ff4d4f' : '#52c41a' }}
				>
					{formatDuration(Math.max(0, 1500 - idleSeconds))}
				</span>
			</span>
			{tokenTTL !== null && (
				<>
					<span>|</span>
					<span>
						Token TTL:{' '}
						<span style={{ color: tokenTTL <= 300 ? '#ff4d4f' : '#52c41a' }}>
							{formatDuration(Math.max(0, tokenTTL))}
						</span>
					</span>
				</>
			)}
		</Space>
	);
};

export default Navbar;
